// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"
import VueI18n from "vue-i18n"
import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(BootstrapVue)

const i18n = new VueI18n({
  locale: "en",
  messages: {
    en: {},
    kr: {}
  }
})

i18n.locale = Vue.config.lang

/* eslint-disable no-new */
new Vue({
  i18n,
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js